// extracted by mini-css-extract-plugin
module.exports = {"image":"UploadCoverPhotoModal_image__1dtC8","upload-image-container":"UploadCoverPhotoModal_upload-image-container__2P4KE"};